import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

import { InputComponent } from '@bp/shared/components/controls';
import { FormFieldControlComponent } from '@bp/shared/components/core';
import { TextMaskConfig } from '@bp/shared/features/text-mask';
import type { IValidatorFunc } from '@bp/shared/features/validation';
import { Validators } from '@bp/shared/features/validation';
import { PaymentCards } from '@bp/shared/models/business';

@Component({
	selector: 'bp-payment-card-expire-input',
	templateUrl: './payment-card-expire-input.component.html',
	styleUrls: [ './payment-card-expire-input.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: PaymentCardExpireInputComponent,
			multi: true,
		},
		{
			provide: NG_VALIDATORS,
			useExisting: PaymentCardExpireInputComponent,
			multi: true,
		},
	],
})
export class PaymentCardExpireInputComponent extends FormFieldControlComponent<string | null> {

	@ViewChild(InputComponent, { static: true }) private readonly _input!: InputComponent;

	mask = new TextMaskConfig({
		placeholderChar: TextMaskConfig.whitespace,
		includeMaskInValue: true,
		guide: false,
		mask: (rawValue: string) => [
			// eslint-disable-next-line array-element-newline
			/\d/u, /\d/u, ' ', '/', ' ', /\d/u, /\d/u,
			...(rawValue.trim().length >= 7 ? [ /\d/u, /\d/u ] : []),
		],
	});

	protected override _validator: IValidatorFunc<string | null> | null = ({ value }) => {
		if (Validators.isEmptyValue(value))
			return null; // don't validate empty values to allow optional controls

		const { month, year } = PaymentCards.parseExpireDateString(value);

		if (Number.isNaN(month) || Number.isNaN(year) || month > 12 || month === 0)
			return { ccExpireDate: null };
		else if (PaymentCards.isExpired(value))
			return { ccExpired: null };

		return null;
	};

	focus(): void {
		this._input.focus();
	}

}
